// extracted by mini-css-extract-plugin
export default {"main":"main_main__kU-oO","str":"main_str__gfG4K","stra":"main_stra__j0olN","strw":"main_strw__3BHiC","strq":"main_strq__+5+so","strt":"main_strt__0R6as"};